import React from "react";

const Dropdown = props => (
  <svg
    width={8}
    height={5}
    viewBox="0 0 8 5"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Clip 287</title>
    <defs>
      <path
        d="M7.95.99L4 4.951c.213.065-.213.065 0 0L.05.99C-.123.526.14 0 1.039 0h5.924c.897 0 1.162.526.988.99z"
        id="a"
      />
    </defs>
    <use fill="#FFF" xlinkHref="#a" fillRule="evenodd" />
  </svg>
);

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Icons/Dropdown.js